export default function CustomH1({ text }: { text: string }) {
	return (
		<h1 className="text-2xl lg:text-3xl font-bold tracking-tight bg-gradient-to-r from-secondary via-secondary/80 to-secondary/90 dark:from-gray-500 dark:via-white/80 dark:to-white/90 bg-clip-text text-transparent animate-gradient bg-[length:200%_auto]">
			{text}
		</h1>
	);
}
